import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ka from './locales/ka.json';

const languageStorageKey = 'camus-language';
const supportedLanguages = ['en', 'ka'] as const;
type SupportedLanguage = (typeof supportedLanguages)[number];

const isSupportedLanguage = (
    value: string | null,
): value is SupportedLanguage => {
    return supportedLanguages.includes(value as SupportedLanguage);
};

const getInitialLanguage = (): SupportedLanguage => {
    if (typeof window === 'undefined') {
        return 'en';
    }

    const storedLanguage = window.localStorage.getItem(languageStorageKey);

    return isSupportedLanguage(storedLanguage) ? storedLanguage : 'en';
};

const applyDocumentLanguage = (language: SupportedLanguage) => {
    if (typeof document === 'undefined') {
        return;
    }

    document.documentElement.lang = language;
};

const initialLanguage = getInitialLanguage();

applyDocumentLanguage(initialLanguage);

i18n.use(initReactI18next).init({
    resources: {
        en,
        ka,
    },
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});

export default i18n;
